import { AlarmAcknowledged } from "./AlarmAcknowledged";
export default AlarmAcknowledged;
